import { useEffect, useState } from "react";
import { BellRing, Users } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { ChatPanel } from "../ChatPanel";

export const ADMIN_GROUP_CHANNEL = "admins:group";

export function AdminGroupChat({ isOwner, pendingTasks, onReminded }) {
  const [busy, setBusy] = useState(false);
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/admin-tasks/admins").then((r) => setMembers(r.data.map((a) => a.name))).catch(() => {}); }, []);
  const remind = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin-tasks/remind-group");
      toast.success(data.count ? `Pengingat ${data.count} tugas dikirim ke grup` : "Tidak ada tugas yang belum dikerjakan");
      onReminded?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-border bg-card overflow-hidden flex flex-col h-[82vh] min-h-[520px]" data-testid="admin-group-chat">
      <div className="flex items-center justify-between gap-2 px-3 py-2 border-b border-border bg-[#0b1324]">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-full bg-sky-500/20 border border-sky-500/40 flex items-center justify-center"><Users className="w-4 h-4 text-sky-400" /></div>
          <div className="leading-tight">
            <div className="font-semibold text-sm text-white" data-testid="admin-group-title">Group Admin Fasnet</div>
            <div className="text-[10px] text-slate-400" data-testid="admin-group-members">{["Anda", ...members].join(", ")} · tag @nama</div>
          </div>
        </div>
        {isOwner && (
          <Button size="sm" variant="outline" disabled={busy} onClick={remind} className="h-7 text-xs text-amber-400 border-amber-500/40 hover:bg-amber-500/10" data-testid="admin-group-remind">
            <BellRing className="w-3.5 h-3.5 mr-1" /> Ingatkan Tugas{pendingTasks ? ` (${pendingTasks})` : ""}
          </Button>
        )}
      </div>
      <div className="flex-1 min-h-0 p-2"><ChatPanel channel={ADMIN_GROUP_CHANNEL} testid="admin-group" compact /></div>
    </div>
  );
}
